import { InjectionToken } from '@angular/core';
import type { ContainerDropList } from './drag-drop.interface';

/**
 * Used to provide a header-drop-list directive to some of the sub-components without causing a circular dependency.
 */
export const HEADER_DROP_LIST = new InjectionToken<ContainerDropList>('HEADER_DROP_LIST');

export const ROW_DROP_LIST = new InjectionToken<ContainerDropList>('ROW_DROP_LIST');
